<template>
  <div id="list">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <van-cell v-for="(item, k) in list" :key="k">
        <router-link :to="{ path: '/live/detail/' + item.id }">
          <div class="item">
            <img :src="item.headimg" alt="" class="head-image" />
            <div>{{ item.title }}</div>
          </div>
        </router-link>
      </van-cell>
    </van-list>
  </div>
</template>

<script>
import config from '@/config'
import { List, Toast } from 'vant'
import { loadThemes } from '@/api/live'

export default {
  name: 'list',
  data() {
    return {
      staticUrl:
        process.env.NODE_ENV === 'development'
          ? config.staticUrl.dev
          : config.staticUrl.pro,
      page: 1,
      list: [],
      loading: false,
      finished: false
    }
  },
  methods: {
    onLoad() {
      // 异步更新数据
      loadThemes({ page: this.page }).then((res) => {
        if (res.code == 1) {
          let result = res.data.rows
          result.forEach((v, k) => {
            this.list.push(v)
          })

          if (res.data.total <= 0){
            this.finished = true
          }
        } else {
          Toast(res.msg)
        }
        this.page++
        this.loading = false
      })
    }
  }
}
</script>

<style scoped lang="less">
.item {
  .head-image {
    width: 100%;
  }
}
</style>
